import getSlugFromUrl from './getSlugFromUrl';
import type { YandexMetrikData } from '~/types/analytics/yandexMetrik';
import { YA_METRIC_ID } from '~/constants/config';
import { useUserStore } from '~/features/user/store';

export const sendYandexMetrika = function (analyticsParams: YandexMetrikData): void {
  const { $logger } = useNuxtApp();
  const userStore = useUserStore();

  if (typeof window === 'undefined') {
    return;
  }

  const log = $logger.withScope('🚩 yandex-metrika');

  const {
    level1,
    level2,
    level3,
    level4 = '',
    level5 = '',
    level6 = '',
    level7 = '',
    level8 = '',
  } = analyticsParams;
  const isAmpPage = (name: string) => name === 'article-amp';

  const userId = String(level3 ?? userStore?.userData?.integer_id ?? 'guest');
  const location = level2 ?? getSlugFromUrl(useRoute().fullPath) ?? '';
  const isAmp = (level7 ?? isAmpPage((useRoute()?.name as string) ?? '')) ? 'AMP' : 'Regular';

  const analyticsData = {
    [level1]: {
      [location]: {
        [userId]: {
          [level4]: { [level5]: { [level6]: { [isAmp]: [level8] } } },
        },
      },
    },
  };

  log(analyticsData);

  if (!window.ym) {
    console.error('window.ym is not defined');
    return;
  }

  window.ym(YA_METRIC_ID, 'params', analyticsData);
};
